<div class="tiny-promo">
  <button pButton type="button" class="p-button-text" label="Back" (click)="back()"></button>
  <h2>{{ detail?.promoCode || 'TinyPromo managed cases' }}</h2>

  <p *ngIf="!detail && !loadError">Loading</p>
  <p *ngIf="loadError" class="tiny-promo__error" role="status">This case could not be loaded.</p>

  <ng-container *ngIf="detail">
    <p *ngIf="actionMessage" [class.tiny-promo__error]="actionError" role="status">{{ actionMessage }}</p>

    <div *ngIf="terminal" class="tiny-promo__verified" role="status">
      <p *ngIf="autoConfirmed"><strong>Verified after confirmation window</strong></p>
      <p *ngIf="!autoConfirmed"><strong>Verification: Customer confirmed</strong></p>
      <p>Verified</p>
      <p>Verified means TinyPromo confirmed the sale. It does not mean the commission has been paid.</p>
    </div>

    <section class="tiny-promo__card">
      <p>Case ID: {{ detail.id }}</p>
      <p>Program: {{ detail.program }}</p>
      <p *ngIf="!terminal">Managed status: {{ statusLabel(detail.status) }}</p>
      <p>Verification: {{ outcomeLabel(detail.verificationOutcome) }}</p>
      <p *ngIf="detail.manualReviewReason">{{ detail.manualReviewReason }}</p>
      <p *ngIf="detail.senderMismatch">Sender mismatch</p>
      <p *ngIf="detail.senderMismatchAfterVerification">A different WhatsApp sender contacted this verified case. Verification was not changed.</p>
      <p *ngIf="detail.senderValidationPending">Sender check pending</p>
    </section>

    <section class="tiny-promo__card">
      <p><strong>Order</strong></p>
      <p>Promo code: {{ detail.order?.promoCode || detail.promoCode }}</p>
      <p>Promotion: {{ detail.order?.promotionId || detail.promotionId }}</p>
      <p>Request: {{ detail.order?.requestId || detail.requestId }}</p>
      <p *ngIf="detail.order?.hubOrderNumber">#{{ detail.order?.hubOrderNumber }}</p>
      <p>{{ detail.order?.hubName }} <span *ngIf="detail.order?.activityName">· {{ detail.order?.activityName }}</span></p>
      <p>Hub: {{ detail.order?.hubId || detail.hubId }}</p>
      <p>{{ detail.order?.contentType || detail.contentType }}</p>
      <p>Customer: {{ detail.order?.customerName || 'No promoter' }}</p>
      <p>Client: {{ detail.order?.clientId || detail.clientId }}</p>
      <p>Order status: {{ detail.order?.orderStatus }}</p>
      <p *ngIf="detail.order?.createdOn">{{ detail.order?.createdOn | date:'medium' }}</p>
      <p *ngIf="detail.order?.updatedOn">{{ detail.order?.updatedOn | date:'medium' }}</p>
      <p>
        Paid / total:
        {{ detail.order?.paidAmount | currency:(detail.order?.currency || detail.commission?.currency || 'DOP') }}
        <span *ngIf="detail.order?.totalAmount"> / {{ detail.order?.totalAmount | currency:(detail.order?.currency || 'DOP') }}</span>
      </p>
    </section>

    <section class="tiny-promo__card">
      <p><strong>WhatsApp</strong></p>
      <p>WhatsApp connection: {{ detail.whatsAppConnectionState || 'WhatsApp not connected yet' }}</p>
      <p>Masked sender: {{ detail.whatsAppSenderNumber || 'WhatsApp not connected yet' }}</p>
      <p *ngIf="detail.whatsAppMessageId">{{ detail.whatsAppMessageId }}</p>
      <p *ngIf="detail.whatsAppConnectedAt">{{ detail.whatsAppConnectedAt | date:'medium' }}</p>
    </section>

    <section class="tiny-promo__card">
      <p><strong>Financial links</strong></p>
      <p>Transaction reference: {{ detail.commission?.transactionRequestId || detail.promoTransactionRequestId }}</p>
      <p>Commission ID: {{ detail.commission?.commissionId || detail.commissionId }}</p>
      <p>Commission status: {{ commissionLabel(detail.commission?.status) }}</p>
      <p>
        Promoter commission:
        {{ detail.commission?.promoterCommissionAmount | currency:(detail.commission?.currency || 'DOP') }}
        ({{ detail.commission?.promoterCommissionRate }}%)
      </p>
      <p>
        TinyPromo fee:
        {{ detail.commission?.tinyPromoFeeAmount | currency:(detail.commission?.currency || 'DOP') }}
        ({{ detail.commission?.tinyPromoFeeRate }}%)
      </p>
      <p>{{ detail.promoterEmail || 'No promoter' }}</p>
    </section>

    <p *ngIf="!terminal && !senderConnected" role="status">No WhatsApp sender is connected to this case.</p>

    <div *ngIf="!terminal" class="tiny-promo__actions">
      <button pButton type="button" label="Confirm completion" (click)="confirm()" [disabled]="!canConfirm"></button>
      <button pButton type="button" class="p-button-outlined" label="Not yet" (click)="notYet()" [disabled]="!canRecordFollowUpOutcome"></button>
      <button pButton type="button" class="p-button-outlined" label="Problem reported" (click)="problem()" [disabled]="!canRecordFollowUpOutcome"></button>
      <button pButton type="button" class="p-button-outlined" label="Unreachable" (click)="unreachable()" [disabled]="!canRecordFollowUpOutcome"></button>
      <button pButton type="button" class="p-button-outlined" label="Mark manual review" (click)="manualReview()" [disabled]="!canReview"></button>
      <span class="follow-up-slot" [class.follow-up-slot--locked]="!canFollowUp">
        <button pButton type="button" class="p-button-outlined" label="Send follow-up"
          [disabled]="!canFollowUp"
          (click)="followUp($event)"
          (keydown)="guardFollowUpKey($event)"></button>
      </span>
    </div>

    <section class="tiny-promo__card">
      <p><strong>History</strong></p>
      <p *ngFor="let entry of detail.history">
        {{ entry.createdAt | date:'medium' }} · {{ entry.type }}
        <span *ngIf="entry.newStatus">· {{ statusLabel(entry.newStatus) }}</span>
        <span *ngIf="entry.reason">· {{ entry.reason }}</span>
      </p>
    </section>
  </ng-container>
</div>
